module.exports = __webpack_public_path__ + "static/media/poweredby-white.d347b4fd.png";